import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        list: [], //table中的list显示数据
        pagination: {}, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },
    /**
     * Vuex 允许我们在 store 中定义“getter”（可以认为是 store 的计算属性）。
     * 就像计算属性一样，getter 的返回值会根据它的依赖被缓存起来，且只有当它的依赖值发生了改变才会被重新计算。
     * 虽说调用mutations中的方法一样能处理，但是会比较的耗性能。
     * 调用规则: this.$store.getters['命名空间/getters中的方法名']
     * 如:
     * this.$store.getters['rc/getDepartmentSelectOptions']
     * 
     * 延伸:
     *    如果getters中的方法直接返回state的话, 那么可以不用定义getters方法进行返回, vue页面直接 this.$store.state.命名空间.key 访问即可
     */
    getters: {
    },
    /**
     * mutations中的方法都是同步的，类似于React Dva中reducers里面的方法。
     * 改变state的唯一方法就是通过mutations中的方法去改变state。
     * mutations中只要一个save方法就行了，思考：为什么只要一个save方法？除非特殊情况？
     * 调用规则: 
     * this.$store.commit({
     *     type: '命名空间/mutations中的方法名', //这里只有一个save
     *     payload: {
     *         对应命名空间中state的key: 新的state的值
     *     }
     * })
     * 如: (可以参考此文件actions的getDepartmentSelectOptions方法中的context.commit写法)
     * this.$store.commit({
     *     type: 'rc/save',
     *     payload: {
     *         departmentSelectOptions: [{
     *             deptid: 1,
     *             deptname: '改变了没??'
     *         }]
     *     }
     * })
     */
    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.departmentSelectOptions = action.payload.departmentSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },
    /**
     * actions中的方法都是异步的，类似于React Dva中effects里面的方法。
     * context 是一个对象, 对应的key有: commit/dispatch/getters/rootGetters/rootState以及state
     * payload 也是一个对象, 对应的key默认有: payload以及type, payload.payload 为调用接口需要传的参数, type默认为   命名空间/方法名
     */
    actions: {
        //查询风控规则列表信息
        select(context, payload) {
            payload.type = 'rc/select'
            // console.log(payload, "payload---------------------------")
            return D.select(payload).then(response => {
                const { data } = response.data
                context.commit({
                    type: 'save',
                    payload: {
                        list: data.list || [],
                        pagination: {
                            total: +data.totalRecords,
                            current: +data.page,
                            pageSize: +data.pageSize,
                        }
                    }
                })
            })
        },
        //新增风控规则 - 页面新增
        add(context, payload) {
            // console.log(context, payload, "???111")
            //定义映射关系, 这边的key  跟 common/api.js 中的API[KEY]对应起来
            return D.add(payload)
        },
        //修改风控规则
        edit(context, payload) {
            return D.edit(payload)
        },
        //删除风控规则
        del(context, payload) {
            return D.del(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'select' })
                return response
            })
        },
        //风控规则详情
        detail(context, payload) {
            return D.detail(payload).then(response => {
                const { data } = response.data
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })
        },
    }
}